<template lang="pug">
.cp-product
  router-view(@showModal="showModal")
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
    }
  },
  computed: {},
  methods: {
    showModal (isShow) {
      this.$emit('showModal', isShow)
    }
  }
}
</script>
<style lang="stylus">
</style>
